export enum AnalyticsEvent {
  Click = 'click',
}

export enum ClickEventType {
  AdBannerClicked = 'ad_banner_clicked',
  BlogShowcaseClicked = 'blog_showcase_clicked',
  ProductCardClicked = 'product_card_clicked',
  BlogCarouselClicked = 'blog_carousel_clicked',
}

export interface TrackClickEvent {
  name: ClickEventType;
  eventProperties: Record<string, unknown>;
}
